export default __webpack_public_path__ + "234c0ff75711229c02efd20b48113fa4.png";